import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../../../core/services/api.service';
import { FaqLangDTO } from '../../DTO/FaqLangDTO';

@Injectable()
export class FaqService {

  constructor(private apiService: ApiService) { }

  getFaq(): Observable<any> {
    return this.apiService.get('https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/FAQ.json')
    .map(
      ( faqDTO: FaqLangDTO[]) => {
        const faqLangMap: Map<string, Map<string, Array<string>>> = new Map();
        faqDTO.forEach((faqLang: FaqLangDTO) => {
          const faqMap: Map<string, Array<string>> = new Map();
          faqLang.FAQs.forEach(faq => {
            faqMap.set(faq.question, faq.answer);
          });
          faqLangMap.set(faqLang.language, faqMap);
        });
        return faqLangMap;
      }
    );
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/faq/faq.service.ts